import _ from 'lodash';
import * as alerts from './alerts';

export function showError(error, title = 'Ошибка') {
    console.error('Error:', error);
    if (!hasNotValidationErrors(error.errors)) return;

    const html = formatError(error.errors);
    alerts.error(html, title);
}

function formatError(errors) {
    return _.join(_.map(errors, error => `[<strong>${error.code}</strong>] ${error.text}`), '<br/>');
}

function hasNotValidationErrors(errors) {
    return _.filter(errors, error => error.code !== '1-0-0-3').length > 0;
}


// WEBPACK FOOTER //
// ./src/helpers/errors.js